/** Display name for a project centre; display labels never change its internal identity. */
export function projectCentreDisplayName(centreWithDomains) {
    const centre = centreWithDomains?.projectCentre ?? centreWithDomains;
    if (!centre) return "-";

    if (centre.remoteId === "default") {
        return "E-shop";
    }

    const name = typeof centre.name === "string" ? centre.name.trim() : "";
    const slug = typeof centre.slug === "string" ? centre.slug.trim() : "";

    if (!name) {
        return slug && slug !== "DEF" ? `[${slug}]` : "-";
    }

    return slug && slug !== "DEF" ? `[${slug}] ${name}` : name;
}

export function projectCentreFilterOption(centreWithDomains) {
    const centre = centreWithDomains?.projectCentre ?? centreWithDomains;

    return {
        value: centre?.id,
        label: projectCentreDisplayName(centre),
    };
}

/** Wait for a successful canonical centre listing before hiding the standalone breakdown. */
export function shouldRedirectSingleCentreReport({projectId, centres, loading, error}) {
    return Boolean(
        projectId
        && !loading
        && !error
        && Array.isArray(centres)
        && centres.length <= 1,
    );
}
